module.exports = __webpack_public_path__ + "static/12-b3ae2985cac99e1f122d88ed6f3421bd.png";